import { Zap, ZapMetadata } from "../types";
import { ZapErrorObject } from "../zaps";

export function isZapErrorObject(
  zap: ZapMetadata | ZapErrorObject | Zap | null,
): zap is ZapErrorObject {
  return !!zap && (zap as ZapErrorObject).error !== undefined;
}
